import React from 'react';

import {Button, Dialogue, Heading, Icon, Modal, Text} from '@albert-io/atomic';

interface Props {
  restrictedCount: number;
  isSubmitting?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

// 20px (text-xl) lock, kept small so it sits below the dialogue's close button.
const LOCK_ICON_CLASS_NAME = 'text-xl';

// Restriction is informational, not blocking; drafts and already-published edits are not gated (at call site).
export function RestrictedQuestionsPublishModal({
  restrictedCount,
  isSubmitting,
  onCancel,
  onConfirm
}: Props) {
  const countNoun = restrictedCount === 1 ? 'question' : 'questions';
  const pronoun = restrictedCount === 1 ? 'this question' : 'these questions';

  return (
    <Modal ariaLabel='Restricted questions in this assignment' handleClose={onCancel}>
      {() => (
        <Dialogue inModal size='m' handleClose={onCancel}>
          <Dialogue.Body align='center'>
            {/* mt-x2 drops the icon below the absolutely-positioned close button. */}
            <div className='mt-x2 flex flex-col items-center gap-x2'>
              <span className='inline-flex items-center justify-center rounded-full bg-background-subtle p-x1-half'>
                <Icon
                  icon='lock'
                  iconStyle='solid'
                  color='secondary'
                  size='inherit'
                  className={LOCK_ICON_CLASS_NAME}
                />
              </span>
              <Heading as='h2' size='s'>
                {`This assignment contains ${restrictedCount} restricted ${countNoun}`}
              </Heading>
              <Text>
                {`Your students can't access ${pronoun} until an admin authorizes this assignment. After you assign, you can request authorization from your admin.`}
              </Text>
            </div>
          </Dialogue.Body>
          <Dialogue.BtnGroup align='center'>
            <Button variant='outlined' color='secondary' onClick={onCancel} disabled={isSubmitting}>
              Cancel
            </Button>
            <Button variant='outlined' color='primary' onClick={onConfirm} disabled={isSubmitting}>
              Assign anyway
            </Button>
          </Dialogue.BtnGroup>
        </Dialogue>
      )}
    </Modal>
  );
}

export default RestrictedQuestionsPublishModal;
